module.exports = __webpack_public_path__ + "img/mm_logo.4656a52d.svg";